import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { Toolbar } from 'react-science/ui';
import { useChartData } from '../context/ChartContext';
import BasicToolBar from './BasicToolBar';
import FunctionToolBar from './FunctionToolBar';
function ToolBarInner({ selectedTool }) {
    return (_jsxs(Toolbar, { orientation: "vertical", children: [_jsx(FunctionToolBar, { defaultValue: selectedTool }), _jsx(BasicToolBar, {})] }));
}
const MemoizedToolBar = memo(ToolBarInner);
export default function ToolBar() {
    const { toolOptions: { selectedTool }, } = useChartData();
    return _jsx(MemoizedToolBar, { selectedTool });
}
